import BaseComponent from 'foundation/base-component';
import React from 'react';
import ReactDOM from 'react-dom';
import { getWebsiteDomain } from 'general/js/helpers';
import { domainConstants } from '../../sso/components/utils/constants/domain-constants';

export default class PlayerHeroComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        if (this.refs.dateOfBirth) {
            this.dateOfBirth = this.getAttribute(this.refs.dateOfBirth, 'options');
            this.age_latest = this.calculateAge(this.dateOfBirth);
            this.render(this.age_latest);
        }

        const websiteDomain = getWebsiteDomain();

        if (this.refs.randaid && websiteDomain === domainConstants.theOpen) {
            this.randaId = this.getAttribute(this.refs.randaid, 'options');
            this.calculatePreviousOpens(this.randaId, this.refs.randaid);
        }
    }

    render(age) {
        ReactDOM.render(
            <div className="player-hero-stats__val"> {age}</div>,
            this.refs.dateOfBirth
        );
    }

    calculateAge(dob) {
        const birthDate = new Date(dob);
        const difference = Date.now() - birthDate.getTime();
        const age = new Date(difference);

        return Math.abs(age.getUTCFullYear() - 1970);
    }

    calculatePreviousOpens(playerId, ref) {
        const url = new URL('/api/PlayerHeroApi/GetPlayerStats', window.location.origin);
        url.searchParams.append('randaID', playerId);

        fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        })
            .then((response) => response.json())
            .then((result) => {
                ReactDOM.render(
                    <div className="player-hero-stats__val"> {result}</div>,
                    ref
                );
            });
    }
}
